module.exports = __webpack_public_path__ + "img/channel_background-600w.3f738112.png";